// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__nUrec","mulShdSpin":"styles_mulShdSpin__vYiEO","loader__overlay":"styles_loader__overlay__9LlMa"};